import React, { useState } from "react";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import Modal from "~/shared/ui/Fields/Modal";
import { MODAL_TITLE, TYPE_OPEN_MODAL } from "../options";
import s from "../RegisterOfDocuments.less";
import { useCopyText } from "~/shared/hooks/useCopyText";
import { SeeCode, SendAcceptAct, SendDeacceptAct } from "./ModalItems";
import { CodeListIProps } from "../index";
import useAcceptAct from "~/entity/Ivideon/hooks/useAcceptAct";
import useDeacceptAct from "~/entity/Ivideon/hooks/useDeacceptAct";

interface ModalsComponentIProps {
  openModal?: string;
  isLoadingLicenses?: boolean;
  codeList?: CodeListIProps[];
  refetch: () => void;
}

const ModalsComponent = ({
  openModal,
  isLoadingLicenses,
  codeList,
  refetch,
}: ModalsComponentIProps) => {
  const [nextStep, setNextStep] = useState(false);
  const { acceptAct } = useAcceptAct();
  const { deacceptAct } = useDeacceptAct();

  const { copyText } = useCopyText();
  const { actId, dealerActId } = useURLParamsGetter<{
    actId: string;
    dealerActId: string;
  }>();
  const setURLParams = useURLParamsSetter();
  const closeModal = () => {
    setURLParams({ openModal: "", dealerActId: "", actId: "" });
  };

  const sendAcceptAct = () => {
    acceptAct({ actId: Number(actId), dealerId: Number(dealerActId) });
    closeModal();
    setTimeout(() => refetch(), 600);
  };

  const sendDeacceptAct = (prop?: string) => {
    deacceptAct({
      actId: Number(actId),
      dealerId: Number(dealerActId),
      comment: prop ?? "",
    });
    closeModal();
    setNextStep(false);
    setTimeout(() => refetch(), 600);
  };

  const handleStep = () => {
    setNextStep((state) => (state ? false : true));
  };

  const handleCopy = () => {
    if (codeList?.length) {
      const textToCopy = codeList
        .map((item) => `${item.licenseCode} ${item.tariffName}`)
        .join("\n");
      copyText(textToCopy);
    }
  };

  return (
    <>
      <Modal
        customClassName={s.seeCode}
        title={
          openModal && !nextStep
            ? MODAL_TITLE[openModal]
            : "Введите причину отклонения"
        }
        actionClose={closeModal}
        withCloseBtn={false}
        isOpen={
          !!openModal &&
          Object.values(TYPE_OPEN_MODAL).includes(openModal as any)
        }
      >
        {openModal === TYPE_OPEN_MODAL.code ? (
          <SeeCode
            isLoadingLicenses={isLoadingLicenses}
            codeList={codeList}
            handleCopy={handleCopy}
            closeModal={closeModal}
          />
        ) : openModal === TYPE_OPEN_MODAL.deacceptAct ? (
          <SendDeacceptAct
            closeModal={closeModal}
            nextStep={nextStep}
            handleStep={handleStep}
            sendDeacceptAct={sendDeacceptAct}
          />
        ) : (
          <SendAcceptAct
            closeModal={closeModal}
            sendAcceptAct={sendAcceptAct}
          />
        )}
      </Modal>
    </>
  );
};
export default ModalsComponent;
